import styled from "styled-components";

export const ButtonWrapper = styled.div`
  margin-top: 2rem;

  > *:not(:last-child) {
    margin-right: 1rem;
  }
`;
